import DeleteFeatureCard from './DeleteFeatureCard';

export default DeleteFeatureCard;
